var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4241_11792)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E2EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3951 36.2267C38.2116 36.2267 42.9269 30.2903 42.9269 22.9673C42.9269 15.6444 38.2116 9.70801 32.3951 9.70801C26.5785 9.70801 21.8634 15.6444 21.8634 22.9673C21.8634 30.2903 26.5785 36.2267 32.3951 36.2267Z",
    fill: "#FFDEB3",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.35 19.6338C43.1238 22.5136 43.0058 25.5527 42.0221 28.3712C41.0122 31.2388 39.1367 33.7632 36.6316 35.6504C36.2906 36.9371 36.4349 38.3096 37.0775 39.4983C37.7727 40.5399 38.8351 41.3119 40.081 41.6673C37.5104 44.0937 35.4642 46.9612 34.0609 50.1106C33.6018 51.2135 32.9986 52.9047 32.0543 52.9292C31.1231 52.9537 30.4149 51.3361 29.7591 50.0371C28.3033 47.1695 26.4802 44.4858 24.3292 42.0349C24.1587 42.084 24.0013 42.1575 23.8177 42.2187C24.7883 41.8634 25.6669 41.2997 26.3358 40.5522C27.5162 39.1429 28.0934 37.366 27.9229 35.5768C25.4834 33.8245 23.6603 31.4348 22.6635 28.7143C22.0602 26.962 21.8241 25.1115 21.9552 23.2856",
    fill: "#FFDEB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.35 19.6338C43.1238 22.5136 43.0058 25.5527 42.0221 28.3712C41.0122 31.2388 39.1367 33.7632 36.6316 35.6504C36.2906 36.9371 36.4349 38.3096 37.0775 39.4983C37.7727 40.5399 38.8351 41.3119 40.081 41.6673C37.5104 44.0937 35.4642 46.9612 34.0609 50.1106C33.6018 51.2135 32.9986 52.9047 32.0543 52.9292C31.1231 52.9537 30.4149 51.3361 29.7591 50.0371C28.3033 47.1695 26.4802 44.4858 24.3292 42.0349C24.1587 42.084 24.0013 42.1575 23.8177 42.2187C24.7883 41.8634 25.6669 41.2997 26.3358 40.5522C27.5162 39.1429 28.0934 37.366 27.9229 35.5768C25.4834 33.8245 23.6603 31.4348 22.6635 28.7143C22.0602 26.962 21.8241 25.1115 21.9552 23.2856",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7029 28.9602C19.9617 27.7715 18.9256 25.5045 19.5682 24.2545C20.0929 23.2496 21.6536 23.0045 22.0077 22.9678C21.8634 24.9898 22.0996 27.0118 22.7029 28.9602Z",
    fill: "white",
    stroke: "#050A4E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13467 60.2452C5.96739 56.4953 12.7481 46.3364 13.6137 45.4663C16.6434 42.3904 24.1718 42.1208 24.3554 42.0596C26.5457 44.486 28.3687 47.1697 29.7851 50.0617C30.3491 51.2382 31.0181 52.6719 31.8969 52.6474C32.6182 52.6351 32.946 51.6548 34.7166 48.6647C35.5166 47.2309 36.4217 45.8462 37.4185 44.5227C38.2185 43.5056 39.1234 42.5498 40.1071 41.6797L40.4744 41.7287C43.9893 41.7777 47.3469 43.1502 49.7732 45.5276C50.7045 46.3609 57.5114 56.4463 56.0163 60.4535C55.072 62.9902 45.4977 64.7303 31.5427 64.7303C18.5977 64.7303 7.94784 62.8676 7.13467 60.2452Z",
    fill: "#FF8E93",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1663 28.1639C44.8943 26.9629 45.9304 24.6959 45.2746 23.4459C44.7107 22.6984 43.8057 22.2205 42.822 22.1592C42.9794 24.1934 42.7565 26.2277 42.1663 28.1639Z",
    fill: "white",
    stroke: "#050A4E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6315 35.6634C36.6315 35.6634 33.51 38.8128 27.949 35.5898",
    stroke: "#050A4E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0081 20.5538C28.8409 20.4803 27.6868 20.7254 26.6506 21.2279L30.0081 20.5538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0081 20.5538C28.8409 20.4803 27.6868 20.7254 26.6506 21.2279",
    stroke: "#050A4E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9396 20.8956C36.1069 20.8221 37.2609 21.0672 38.2971 21.5819L34.9396 20.8956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9396 20.8956C36.1069 20.8221 37.2609 21.0672 38.2971 21.5819",
    stroke: "#050A4E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8933 23.9115C29.3641 23.9115 29.7459 23.5548 29.7459 23.1149C29.7459 22.675 29.3641 22.3184 28.8933 22.3184C28.4225 22.3184 28.0408 22.675 28.0408 23.1149C28.0408 23.5548 28.4225 23.9115 28.8933 23.9115Z",
    fill: "#050A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9495 23.9115C36.4204 23.9115 36.8021 23.5548 36.8021 23.1149C36.8021 22.675 36.4204 22.3184 35.9495 22.3184C35.4787 22.3184 35.097 22.675 35.097 23.1149C35.097 23.5548 35.4787 23.9115 35.9495 23.9115Z",
    fill: "#050A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1492 27.8936C31.4902 28.1999 31.9623 28.3592 32.4476 28.3224C32.8148 28.2857 33.1558 28.1386 33.4181 27.8936",
    stroke: "#050A4E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4572 30.3691C30.3228 31.1412 31.4902 31.5333 32.6838 31.4475C33.6018 31.3495 34.4543 30.9819 35.097 30.3691",
    stroke: "#050A4E",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9968 43.4991C16.4427 46.1094 17.5182 48.9401 20.5479 49.6386C23.053 50.2146 25.9646 49.222 27.3942 47.2122C27.9975 46.3544 27.9844 45.129 28.0631 44.1486C28.273 41.6732 28.7582 38.4748 28.0631 36.0362C25.6892 34.051 23.9186 31.4653 22.9612 28.5732C21.9119 25.7915 21.807 22.7524 22.6595 19.8971C23.6301 16.9315 26.1745 13.1571 28.2992 13.4757C30.096 13.7453 30.0173 16.7232 32.6142 19.5417C34.8832 21.8088 37.8998 23.2425 41.1393 23.5857C41.3623 23.5857 41.8869 23.5489 41.9263 23.5489C41.9656 23.5489 42.005 23.5489 42.0574 23.5489C42.5296 23.5489 42.2148 26.7473 41.3885 28.9286C40.3786 31.6246 38.6736 34.0265 36.4309 35.8891C36.221 37.9479 36.5095 40.1292 36.7587 42.1757C37.0604 44.7001 38.3064 47.4451 40.3918 49.1362C41.4017 49.9572 42.687 50.5209 44.0117 50.5209C45.3626 50.5209 46.6741 49.9327 47.6315 49.0504C49.7563 47.102 49.8087 44.4673 49.8612 41.8816C49.9268 38.7934 49.3759 35.6931 48.248 32.801C47.5922 31.0976 46.7397 29.4433 46.2413 27.6909C45.756 25.9385 45.9134 24.2719 46.0577 22.495C46.3462 18.8799 46.6479 15.4242 44.3658 12.2625C41.323 8.1573 36.3653 5.80444 31.1715 6.01276C27.7483 6.14756 24.4957 7.54457 22.1086 9.94644C18.8166 13.2429 20.1151 18.5736 19.4068 22.6421C18.1477 29.7374 14.7246 36.073 15.9968 43.4991Z",
    fill: "#474748",
    stroke: "#2D2D2D",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4241_11792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/FemaleIcon.bfb0b2cefd83d0b829b0bc856b5dbdf1.svg";
export { ForwardRef as ReactComponent };